export const FETCH_CUSTODIANS_REQUEST = 'FETCH_CASTODIANS_REQUEST' as const;
export const FETCH_CUSTODIANS_FAILURE = 'FETCH_CASTODIANS_FAILURE' as const;
export const FETCH_CUSTODIANS_SUCCESS = 'FETCH_CASTODIANS_SUCCESS' as const;
export const UPDATE_CUSTODIANS_REQUEST = 'UPDATE_CASTODIANS_REQUEST' as const;
export const UPDATE_CUSTODIANS_FAILURE = 'UPDATE_CASTODIANS_FAILURE' as const;
export const DELETE_CUSTODIAN = 'DELETE_CASTODIAN' as const;
export const ADD_NEW_CUSTODIAN = 'ADD_NEW_CASTODIAN' as const;
export const SEARCH_CUSTODIANS_REQUEST = 'SEARCH_CUSTODIANS_REQUEST' as const;
export const SEARCH_CUSTODIANS_SUCCESS = 'SEARCH_CUSTODIANS_SUCCESS' as const;
export const SEARCH_CUSTODIANS_FAILURE = 'SEARCH_CUSTODIANS_FAILURE' as const;
export const ADD_CUSTODIAN_DATA = 'ADD_CUSTODIAN_DATA' as const;
export const CUSTODIAN_DETAILS_LOADING = 'CUSTODIAN_DETAILS_LOADING' as const;
export const CUSTODIAN_DETAILS_FAILURE = 'CUSTODIAN_DETAILS_FAILURE' as const;
